"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _toolTipModule = _interopRequireDefault(require("./toolTip.module.css"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tooltip = function Tooltip(props) {
  var id = props.id,
      text = props.text;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_toolTipModule.default["tooltip"], _toolTipModule.default["fade"], _toolTipModule.default["top"], _toolTipModule.default["in"], _toolTipModule.default["centered"]),
    role: "tooltip"
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_arrow") : null,
    className: _toolTipModule.default["tooltip-arrow"]
  }), _react.default.createElement("div", {
    id: id ? "".concat(id, "_inner_text") : null,
    className: _toolTipModule.default["tooltip-inner"]
  }, text));
};

var _default = Tooltip;
exports.default = _default;
Tooltip.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text ToolTip */
  text: _propTypes.default.string
};